"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var $ = require("../../jquery-3.3.1.js");
//light window utilities
var numberlwindows = 0;
var lightwindowpreloader = '<div class="lightwindow-preloader"><img src="/images/loader.gif" /></div>';
exports.lightwindowpreloader = lightwindowpreloader;
(function ($) {
    $(window).resize(function () {
        $('.lwindow:visible').each(function () {
            resizelw($(this));
        });
    });
}($));
function resizelw($lw) {
    var scroll = $lw.attr('data-scroll');
    if (scroll === 0 || typeof scroll === 'undefined' || $lw.parent().is('#cover') || $lw.outerHeight(true) < $('#cover').height()) {
        var topval = 0;
        topval = Math.max(($(window).height() - $lw.height() - 20) / 2, topval);
        $lw.css('top', String(topval) + "px");
        $lw.attr('data-scroll', 0);
    }
}
var htmloverflow;
var bodyoverflow;
var htmlscrolltop;
//keypress
$(document).on('keyup.lw', lightwindowKeyControls);
function lightwindowKeyControls(event) {
    var e = event;
    switch (e.which) {
        case 27: // esc
            e.preventDefault();
            //trigger close window
            if ($('#cover').find('.js-generatingquotepanel').length === 0) {
                closePopUp($('#cover .js-lightwindow'));
            }
            break;
        case 13: // enter
            e.preventDefault();
            //trigger submit button
            $('#cover .js-lightwindow').find('.js-lightwindow-submit').click();
            break;
        default: return; // exit this handler for other keys
    }
}
exports.lightwindowKeyControls = lightwindowKeyControls;
var cvr_mousedowntarget;
function createPopUpCover() {
    $('html').addClass('js-stopscroll');
    var $cvr = $('#cover');
    if (!$cvr[0]) {
        $cvr = $('<div id="cover" class="lightwindowcover js-lightwindowcover" style="display:none;"></div>');
        $('body').prepend($cvr.click(function (event) {
            if (!$(event.target).closest('.lwindow').is('.lwindow') && !$(cvr_mousedowntarget).closest('.lwindow').is('.lwindow')) {
                closePopUpAll();
            }
        }).mousedown(function (event) {
            cvr_mousedowntarget = event.target;
        }));
    }
    $cvr = $('#cover2');
    if (!$cvr[0]) {
        $cvr = $('<div id="cover2" class="lightwindowcover" style="z-index:10000;display:none;background:none;"></div>');
        $('body').prepend($cvr);
    }
}
function createPopUp(elemid) {
    var $lw = (elemid.indexOf('div_lw') == 0 ? $('#' + elemid) : $('.js-' + elemid));
    if (!$lw[0]) {
        $lw = $('<div' + (elemid.indexOf('div_lw') == 0 ? ' id="' + elemid + '"' : '') + ' class="lwindow lightwindow ' + elemid + ' js-lightwindow js-' + elemid + '" style="display:none;"></div>');
        $('body').prepend($lw);
    }
    else {
        $lw.attr('class', 'lwindow lightwindow ' + elemid + ' js-lightwindow js-' + elemid);
    }
    return $lw;
}
exports.createPopUp = createPopUp;
function showPopUp(elemid, keeplwposition) {
    var $lw = (typeof (elemid) == 'string' ? $('#' + elemid) : elemid);
    if (!$('#cover:visible')[0]) {
        htmloverflow = $('html').css('overflow') || 'visible';
        bodyoverflow = $('body').css('overflow') || 'visible';
        $('#cover, #cover2').css({ 'overflow-y': 'scroll' });
        createPopUpCover();
        $('#cover,#cover2').show();
    }
    $('body,html').css('overflow', 'hidden');
    var scrolltop = $('#cover').scrollTop() || 0;
    if (!$lw.is(':visible')) {
        numberlwindows = numberlwindows + 1;
        $lw.show();
        $lw.css({ 'z-index': 10000 + numberlwindows * 2 });
        if (window.location.href.toString().toLowerCase().indexOf('buildmyquote.aspx') < 0 && window.location.href.toString().toLowerCase().indexOf('default_compare.aspx') < 0 && window.location.href.toString().toLowerCase().indexOf('appexpress.aspx') < 0) {
            $lw.css({ 'width': $lw.width() + 'px', 'margin': '0px auto', 'position': 'relative' });
        }
        $('#cover').css('z-index', 10000 + numberlwindows * 2 - 1);
        $('#cover').css({ 'width': '', 'height': '' }); //temporary fix to undo styling from old lightwindows
        $('#cover').scrollTop(0);
    }
    if ($lw.find('.js-lightwindow-close')) {
        $lw.find('.js-lightwindow-close').unbind('click').click(function () {
            closePopUp($lw);
        });
    }
    if (!keeplwposition) {
        resizelw($lw);
    }
    $('#cover').children().each(function () {
        //scrolltop is #cover scrollTop upon calling showPopUp
        $('#cover2').prepend($(this).attr('data-scroll', scrolltop));
        if (scrolltop > 0) {
            $(this).css({ 'top': scrolltop * -1 });
        }
        else {
            $(this).css({ 'top': '' });
        }
    });
    scrolltop = $lw.attr('data-scroll', scrolltop);
    if (scrolltop > 0) {
        $lw.css({ 'top': scrolltop * -1 });
    }
    else {
        resizelw($lw);
    }
    $('#cover').append($lw /*.unbind('click').click(function(event){event.stopPropagation();return false;})*/);
}
exports.showPopUp = showPopUp;
function closePopUp(elemid, nofurtheraction) {
    var $lw = (typeof (elemid) == 'string' ? $('#' + elemid) : elemid);
    if ($lw.is(':visible')) {
        var $nxtlw = $('#cover2').children('.lwindow:visible').eq(0);
        var scrolltop = 0;
        if ($nxtlw.attr('data-scroll'))
            scrolltop = $nxtlw.attr('data-scroll');
        if (scrolltop > 0 && $nxtlw.outerHeight(true) > $('#cover').height()) {
            $nxtlw.css({ 'top': '' });
        }
        else {
            $nxtlw.attr('data-scroll', 0);
            scrolltop = 0;
        }
        //closed lightwindow so reset it's position/scroll
        $lw.attr('data-scroll', 0);
        $lw.css({ 'top': '' });
        $('#cover').append($nxtlw);
        if (scrolltop === 0) {
            resizelw($nxtlw);
        }
        $('#cover').scrollTop(scrolltop);
        $lw.hide();
        $('#cover').after($lw);
        numberlwindows = numberlwindows - 1;
        $('#cover').css('z-index', 10000 + numberlwindows * 2 - 1);
    }
    if ($('#cover')[0] && !hasPopUp($lw)) {
        $('html').css('overflow', htmloverflow);
        $('body').css('overflow', bodyoverflow);
        $('#cover, #cover2').css({ 'overflow-y': 'hidden' });
        $('#cover, #cover2').fadeOut('fast', function () { $(this).hide(); });
        if (htmlscrolltop > 0)
            $(window).scrollTop(htmlscrolltop);
        $('html').removeClass('js-stopscroll');
    }
}
exports.closePopUp = closePopUp;
function hasPopUp(elemid) {
    var $lw = (typeof (elemid) == 'string' ? $('#' + elemid) : elemid);
    return $('.lwindow:visible').not($lw).length > 0;
}
function closePopUpAll() {
    //if($('#div_lwbuildquote:visible')[0]) return;
    //if($('#div_lwpolicymatcher:visible')[0]&&$('#div_lwpolicymatcher .lwtitle90').length==2) return;
    //if($('#div_lwcompareperson:visible')[0]) compare_cancelperson();
    //if($('#div_lw_tvad:visible')[0]) $('#div_lw_tvad iframe').remove();
    //if($('#div_lwvideohome:visible')[0]) $('#div_lwvideohome iframe').remove();
    //if($('#div_lwapply2way:visible')[0]) $('#hdnProviderID').val(0);
    $('.lwindow').hide();
    $('#cover').children().each(function () {
        $('#cover2').prepend($(this));
        $(this).attr('data-scroll', 0);
        $(this).css({ 'top': '' });
    });
    $('#cover').scrollTop(0);
    $('#cover, #cover2').css({ 'overflow-y': 'hidden' });
    $('html').css('overflow', htmloverflow);
    $('body').css('overflow', bodyoverflow);
    $('#cover, #cover2').fadeOut('fast', function () { $(this).hide(); });
    if (htmlscrolltop > 0)
        $(window).scrollTop(htmlscrolltop);
    numberlwindows = 0;
    $('html').removeClass('js-stopscroll');
}
//# sourceMappingURL=lightwindowutility.js.map